var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSavedReply(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "2lwb862tza",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 16,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.667 3.333h6.576A4.167 4.167 0 0 1 17.41 7.5v3.334A4.167 4.167 0 0 1 13.243 15h-2.649l.08 1.598a.833.833 0 0 1-1.481.564L7.455 15h-.788A4.167 4.167 0 0 1 2.5 10.834V7.5a4.167 4.167 0 0 1 4.167-4.167zm2.595 11.734a1.333 1.333 0 0 1 1.332-1.4h2.65a2.833 2.833 0 0 0 2.833-2.833V7.5a2.833 2.833 0 0 0-2.834-2.833H6.667A2.833 2.833 0 0 0 3.833 7.5v3.334a2.833 2.833 0 0 0 2.834 2.833h.788c.404 0 .786.183 1.04.498l.77.96-.003-.058zm-3.012-4.65a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667zm4.583-.833a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0zm2.917.833a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#2lwb862tza)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M0 0h20v20H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSavedReply);
export default __webpack_public_path__ + "static/media/ic-saved-reply.6db39fb81c44650383b5d24d7fd1f560.svg";
export { ForwardRef as ReactComponent };